module.exports = __webpack_public_path__ + "static/img/jingyingxiaozu@3x.2ca0d59.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/views/studyCenter/switch/group/img/jingyingxiaozu@3x.png
// module id = ZRhS
// module chunks = 96